document.addEventListener('DOMContentLoaded', function(){
  var items = document.querySelectorAll('.tooltip');
  
  items.forEach(item => {
    item.addEventListener('mouseenter', () => {
      items.forEach(el => el.classList.add('hovered'));
    });
    item.addEventListener('mouseleave', () => {
      items.forEach(el => el.classList.remove('hovered'));
    });
  });
}, false);

function toggleReadMore(element, to_open) {
  //console.log(block);
  var parent = element.parentElement.parentElement;
  //parent.classList.toggle("open")
  if(to_open){
    parent.classList.add("open");
  } else {
    parent.classList.remove("open");
  }
}